<template>
  <div class="card-footer py-4">
    <nav>
      <div class="row align-items-center">
        <div class="col-md-6">
          <span class="text-muted">
            Showing {{ paginationStart }} to {{ paginationEnd }} of
            {{ totalItems }} {{ itemLabel }}
          </span>
        </div>
        <div class="col-md-6">
          <ul class="pagination justify-content-end mb-0">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a class="page-link" href="#" @click.prevent="prevPage">
                <i class="fas fa-angle-left"></i>
              </a>
            </li>
            <li
              v-for="page in visiblePages"
              :key="page"
              class="page-item"
              :class="{ active: currentPage === page }"
            >
              <a class="page-link" href="#" @click.prevent="goToPage(page)">
                {{ page }}
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
            >
              <a class="page-link" href="#" @click.prevent="nextPage">
                <i class="fas fa-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "TablePagination",
  props: {
    // Current page number (1-indexed)
    currentPage: {
      type: Number,
      required: true,
    },
    // Number of items per page
    perPage: {
      type: Number,
      default: 15,
    },
    // Total number of items
    totalItems: {
      type: Number,
      required: true,
    },
    // Label for items (e.g., "employees", "tips")
    itemLabel: {
      type: String,
      default: "items",
    },
    // Number of page links to show on each side of current
    pageDelta: {
      type: Number,
      default: 2,
    },
  },
  emits: ["update:currentPage"],
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.perPage);
    },
    paginationStart() {
      if (this.totalItems === 0) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    paginationEnd() {
      return Math.min(this.currentPage * this.perPage, this.totalItems);
    },
    visiblePages() {
      const pages = [];
      for (
        let i = Math.max(1, this.currentPage - this.pageDelta);
        i <= Math.min(this.totalPages, this.currentPage + this.pageDelta);
        i++
      ) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    goToPage(page) {
      this.$emit("update:currentPage", page);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.$emit("update:currentPage", this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit("update:currentPage", this.currentPage + 1);
      }
    },
  },
};
</script>
